import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  storeId() {
    return faker.random.alphaNumeric(5);
  },

  accessToken() {
    return faker.random.alphaNumeric(15);
  },

  showShopBranding: true,

  shopBrandingName() {
    return faker.company.name();
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },
});
